const React = require("react");
const Layout = require("./src/components/Layout/Layout").default;
const PageTransition = require("./src/components/PageTransition/PageTransition").default;

exports.wrapPageElement = ({ element, props }) => {
  return React.createElement(
    Layout,
    props,
    React.createElement(PageTransition, { location: props.location }, element)
  );
};

exports.onRouteUpdate = ({ location: _location }) => {
  const panel = document.getElementById("main-panel");
  if (panel) {
    panel.scrollTo(0, 0);
  }
};
